import React from 'react';

function Subsection({ children }: { children?: any }){
  return children ? (
    <div className="editor__wizard__subsection">{children}</div>
  ) : null;
}

export default Subsection;
